import ru from '../public/locales/ru.json';
import en from '../public/locales/en.json';
import uk from '../public/locales/uk.json';

const locales = {
    ru,
    en,
    uk
};

export default locales;
